<nav class="pagination-nav">
    <ul class="pagination justify-content-center">

      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="javascript:void(0);" aria-label="Previous" (click)="goToPage(currentPage - 1)">
          <span aria-hidden="true"><i class="fa-solid fa-chevron-left"></i></span>
        </a>
      </li>

      <li class="page-item" *ngFor="let page of visiblePages" [class.active]="page === currentPage">
        <a class="page-link" href="javascript:void(0);" (click)="goToPage(page)">{{ page }}</a>
      </li>

      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="javascript:void(0);" aria-label="Next" (click)="goToPage(currentPage + 1)">
          <span aria-hidden="true"><i class="fa-solid fa-chevron-right"></i></span>
        </a>
      </li>

    </ul>
</nav>
